module.exports = __webpack_public_path__ + "img/GIF.cc5362c2.svg";